import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import concatWithSpaces from "components/ProjectNonSpecificComponents/Functions/concatWithSpaces"
import React, { forwardRef, useEffect, useState } from "react"
import Icon from "./Icons/Icon/Icon"

interface Props {
	width?: string | number
	height?: string | number
	/**
	 * Color for the (1) border, (2) background fill, if checked.
	 */
	primaryColor?: string
	/**
	 * Color for the (1) checkmark, (2) the background, if unchecked.
	 */
	secondaryColor?: string
	readOnly?: boolean
	checked?: boolean
	onCheck?: (checked: boolean) => void
}

const Checkbox = forwardRef<HTMLDivElement, Props>(
	(
		{
			width = 28,
			height = 28,
			primaryColor = "var(--blue)",
			secondaryColor = "var(--white)",
			readOnly = false,
			checked: controlledChecked = false,
			onCheck = () => {},
			...props
		},
		ref
	) => {
		const [checked, setChecked] = useState<boolean>(controlledChecked)

		useEffect(() => {
			setChecked(controlledChecked)
		}, [controlledChecked])

		return (
			<HyperDiv
				className={concatWithSpaces(readOnly ? "" : "pointer")}
				style={{
					width,
					height,
					backgroundColor: checked ? primaryColor : "var(--white)",
					opacity: readOnly ? 0.5 : 1,
					border: `1px solid ${checked ? primaryColor : "var(--gray-c2)"}`,
					borderRadius: 5,
				}}
				ref={ref}
				centered
				onClick={() => !readOnly && onCheck(!checked)}
			>
				{checked && <Icon iconKey="check" iconColor={secondaryColor} />}
			</HyperDiv>
		)
	}
)

export default Checkbox
